// extracted by mini-css-extract-plugin
module.exports = {"root":"FileUploader_root__14GJD","uploadStatus":"FileUploader_uploadStatus__3G13_","uploading":"FileUploader_uploading__3QaNO"};